import React from 'react';
import { Button } from '../../../components/ui/Button';
import { Product } from '../../../types/products';
import { formatRupiah } from '../../../utils/format';

export type DetailViewProps = {
  data: Product | null;
  loading?: boolean;
  error?: string | null;
  onBack: () => void;
  onEdit: (id: string) => void;
};

export const ProductDetailView: React.FC<DetailViewProps> = ({ data, loading, error, onBack, onEdit }) => {
  return (
    <div className="w-full">
      <div className="mb-3 flex items-center justify-between">
        <h1 className="text-xl font-semibold">Product Details</h1>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onBack}>Back</Button>
          {data && <Button onClick={() => onEdit(data.id)}>Edit</Button>}
        </div>
      </div>
      {loading && <div>Loading...</div>}
      {error && <div className="text-sm text-destructive">{error}</div>}
      {data && (
        <div className="rounded border p-4">
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <Field label="ID" value={String(data.id)} />
            <Field label="SKU" value={data.sku || '-'} />
            <Field label="Name" value={data.name} />
            <Field label="Price" value={formatRupiah(data.price)} />
            <div className="md:col-span-2">
              <div className="text-xs text-muted-foreground">Image</div>
              {data.imageUrl ? (
                <img src={data.imageUrl} alt={data.name} className="mt-1 h-40 w-40 rounded object-cover border" />
              ) : (
                <div className="mt-1 text-sm">-</div>
              )}
            </div>
            <div className="md:col-span-2">
              <Field label="Description" value={data.description || '-'} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Field: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div>
    <div className="text-xs text-muted-foreground">{label}</div>
    <div className="mt-1 text-sm">{value}</div>
  </div>
);

export default ProductDetailView;
